import { CONFIG } from './config.js';

/**
 * 速度テーブル
 *
 * from,to は 0～1
 */
const SPEED_TABLE = [
	{
		from: 0,
		to: 0.5,
		speed: CONFIG.autoSpeedMin,
	},
	{
		from: 0.5,
		to: 0.75,
		speed: CONFIG.autoSpeedMax,
	},
	{
		from: 0.75,
		to: 1,
		speed: CONFIG.autoSpeedMin,
	},
];

/**
 * 自動回転
 */
export const updateAutoRotation = ({
	step,
	offset,
	targetRotation,
	rotationY,
	pauseUntil,
	delta,
}) => {

	//------------------------------------
	// 一時停止中
	//------------------------------------
	if (Date.now() < pauseUntil) {
		return targetRotation;
	}
	//------------------------------------
	// 現在位置
	//------------------------------------
	const local =
		(
			(rotationY - offset) %
			step +
			step
		) %
		step;
	//------------------------------------
	// 0～1へ変換
	//------------------------------------
	const progress = local / step;
	//------------------------------------
	// 速度取得
	//------------------------------------
	const current =
		SPEED_TABLE.find(item =>
			progress >= item.from &&
			progress < item.to
		);
	const speed =
		current
			? current.speed
			: CONFIG.autoSpeedMin;
	//------------------------------------
	// target更新
	//------------------------------------
	return targetRotation - speed * delta * 60;
};
